export class VehicleQueryParameters {
  apxCode?: string;
  associateId?: string;
  businessManagerId?: string;
  categoryId?: string;
  codeId?: string;
  colourId?: string;
  convertibleFlag?: string;
  disableUpdateVehicleInfo?: boolean;
  driverId?: string;
  driveTrain?: string;
  embed?: Array<string>;
  embedded?: any;
  engine?: string;
  enteredDateFrom?: Date;
  enteredDateTo?: Date;
  extendedWarrantyId?: string;
  extendedWarrantyPlanId?: string;
  exteriorColourCode?: string;
  genericModelId?: string;
  gmDrivingCondition?: string;
  groupId?: string;
  hscCode?: string;
  id?: string;
  interiorColourCode?: string;
  keyCodeDoor?: string;
  keyCodeIgnition?: string;
  leaseVehicleOperatorId?: string;
  licensePlateNumber?: string;
  make?: string;
  manufacturerId?: string;
  modifiedDateFrom?: Date;
  modifiedDateTo?: Date;
  retailDealerNumber?: string;
  rooftopId?: number;
  optimumUsedFlag?: string;
  orderDate?: Date;
  orderNumber?: string;
  page?: number;
  pageSize?: number;
  passengerFlag?: string;
  prospectTypeId?: string;
  regularWarrantyId?: string;
  saleId?: string;
  salespersonId?: string;
  search?: string;
  soldDateFrom?: Date;
  soldDateTo?: Date;
  statusCode?: string;
  stockNumber?: string;
  subCategoryId?: string;
  subTypeId?: string;
  typeId?: string;
  vin?: string;
  year?: number;

  constructor(obj?: VehicleQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class LastWorkOrderForVehicleQueryParameters {
  serviceGroupId?: string;

  constructor(obj?: LastWorkOrderForVehicleQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
